// 다운로드 버튼 비활성화 — 이 파일에서 주석 처리된 코드는 모두 다운로드 기능이다.
// 서버 이미지는 S3 공개 url(cross-origin)이라 <a download>가 무시되고, blob fetch는 버킷 CORS에 막혀
// 새 탭으로만 열린다. presign API(POST /uno-files/{id}/presign)도 inline disposition이라 결과가 같다.
// BE에서 attachment 다운로드를 지원하면 주석을 풀어 복구한다.
// import React, { useEffect, useState } from "react";
import React from "react";
// import { Flex, IconButton, Image, ModalFooter, Text } from "@chakra-ui/react";
import { Flex, Image, ModalFooter, Text } from "@chakra-ui/react";
import AppButton from "@/features/line-sheet-sets/app-button";
import CustomApprovalModal from "@/shared/components/custom-modal";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
// import CustomIcon from "../../../../../../../public/icons-v1_1";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  fileName: string;
  // 미리보기 src — 로컬 파일이면 objectURL, 서버 저장본이면 S3 url
  src: string;
  // 새로 선택한 로컬 파일 — 있으면 서버 url 대신 이 파일을 그대로 내려받는다 (복구 시 구조분해에도 추가)
  // file: File | null;
}

// function triggerDownload(href: string, fileName: string) {
//   const anchor = document.createElement("a");
//   anchor.href = href;
//   anchor.download = fileName;
//   document.body.appendChild(anchor);
//   anchor.click();
//   anchor.remove();
// }

// 상세페이지 상/하단 기본 이미지로 올린 파일을 다시 확인하는 모달
function PathPickBasketTemplateImagePreviewModal({
  isOpen,
  onClose,
  title,
  fileName,
  src,
}: Props) {
  const { t } = useI18nHelper();
  // const [isImageBroken, setIsImageBroken] = useState(false);
  // const [isDownloading, setIsDownloading] = useState(false);
  //
  // useEffect(() => {
  //   setIsImageBroken(false);
  // }, [src]);
  //
  // const handleDownload = async () => {
  //   if (file) {
  //     const objectUrl = URL.createObjectURL(file);
  //     triggerDownload(objectUrl, file.name);
  //     URL.revokeObjectURL(objectUrl);
  //     return;
  //   }
  //
  //   // S3는 cross-origin이라 <a download>가 무시된다 — blob으로 받아 같은 출처 URL로 바꿔 내려받는다.
  //   setIsDownloading(true);
  //   try {
  //     const response = await fetch(src);
  //     if (!response.ok) {
  //       throw new Error(`${response.status}`);
  //     }
  //     const objectUrl = URL.createObjectURL(await response.blob());
  //     triggerDownload(objectUrl, fileName);
  //     URL.revokeObjectURL(objectUrl);
  //   } catch {
  //     // 버킷 CORS가 GET을 막으면 fetch가 실패한다 — 새 탭으로 열어 직접 저장하게 한다.
  //     window.open(src, "_blank", "noopener,noreferrer");
  //   } finally {
  //     setIsDownloading(false);
  //   }
  // };

  return (
    <CustomApprovalModal
      isOpen={isOpen}
      onClose={onClose}
      // 화면보다 넓으면 왼쪽이 스크롤로도 닿지 않아 화면 폭으로 클램프한다.
      minWidth={"min(560px, 92dvw)"}
      // 세로로 긴 상세페이지 이미지라 모달 안에서만 스크롤되게 한다.
      scrollBehavior={"inside"}
      isCentered={true}
    >
      <CustomApprovalModal.Header
        onClose={onClose}
        title={
          // 공용 Header는 title과 닫기 버튼만 양끝 배치하므로, 다운로드 버튼은 title 안 오른쪽 끝에 둬 X 옆에 붙인다.
          <Flex flex={1} minWidth={0} alignItems={"center"} gap={"8px"}>
            <Flex flexDirection={"column"} gap={"2px"} flex={1} minWidth={0}>
              <Text textStyle={"body-md-bold"} color={"#444444"}>
                {title}
              </Text>
              <Text
                textStyle={"body-sm-regular"}
                color={"#8F8F8C"}
                wordBreak={"break-all"}
              >
                {fileName}
              </Text>
            </Flex>
            {/* {!isImageBroken && (
              <IconButton
                aria-label={t(
                  "path_pick:basket.buyer_info.image_preview.download"
                )}
                title={t("path_pick:basket.buyer_info.image_preview.download")}
                icon={<CustomIcon src={"download"} width={20} height={20} />}
                variant={"ghost"}
                onClick={handleDownload}
                isLoading={isDownloading}
                color={"#8F8F8C"}
                size={"sm"}
                _hover={{ background: "transparent" }}
              />
            )} */}
          </Flex>
        }
      />
      <CustomApprovalModal.Body>
        <Image
          src={src}
          alt={fileName}
          width={"100%"}
          height={"auto"}
          // onError={() => setIsImageBroken(true)}
        />
      </CustomApprovalModal.Body>
      {/* 확인 버튼만 필요해서 공용 Footer(취소 버튼 고정 노출) 대신 직접 렌더한다.
          본문이 스크롤되므로 ModalBody 밖(ModalFooter)에 둬야 버튼이 따라 올라가지 않는다. */}
      <ModalFooter padding={"12px 16px"}>
        <AppButton variant={"primary"} width={"80px"} onClick={onClose}>
          <Text textStyle={"body-sm-bold"}>{t("common:confirm")}</Text>
        </AppButton>
      </ModalFooter>
    </CustomApprovalModal>
  );
}

export default PathPickBasketTemplateImagePreviewModal;
